const GlobalStyles = {
  formContainer: {
    margin: "0 auto",
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },

  section: {
    borderRadius: "6px",
    border: "1px solid #eaeaea",
    backgroundColor: "#ffffff",
  },

  sectionContainer: {
    backgroundColor: "#ffffff",
    borderRadius: "6px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    marginBottom: "20px",
  },

  chartContainer: {
    width: "100%",
    borderRadius: "8px",
    marginTop: "20px",
    marginBottom: "20px",
    backgroundColor: "#f8f9fa",
    border: "1px solid #ddd",
    padding: "15px",
  },

  header: {
    color: "#2a5885",
    marginTop: "0",
    marginBottom: "15px",
    borderBottom: "2px solid #e1e4e8",
    paddingBottom: "10px",
  },

  subHeader: {
    color: "#2a5885",
    marginTop: "20px",
    marginBottom: "10px",
    fontSize: "18px",
  },

  title: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#2a5885",
    marginTop: "0",
    marginBottom: "15px",
    textAlign: "center",
    borderBottom: "2px solid #e1e4e8",
    paddingBottom: "10px",
  },

  pageTitle: {
    textAlign: "center",
    fontSize: "28px",
    color: "#2a5885",
    marginTop: "0",
    marginBottom: "15px",
    borderBottom: "2px solid #e1e4e8",
    paddingBottom: "10px",
  },

  label: {
    display: "block",
    fontWeight: "500",
    color: "#333",
    marginBottom: "4px",
  },

  input: {
    width: "100%",
    padding: "8px 12px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    marginTop: "4px",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  },

  select: {
    width: "100%",
    padding: "8px 12px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    marginTop: "4px",
    backgroundColor: "#fff",
  },

  formGroup: {
    marginBottom: "5px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "15px",
  },

  button: {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.15s ease-in-out",
  },

  secondaryButton: {
    backgroundColor: "#6c757d",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    marginTop: "20px",
    transition: "background-color 0.15s ease-in-out",
  },

  error: {
    color: "#dc3545",
    backgroundColor: "#f8d7da",
    padding: "10px",
    borderRadius: "4px",
    marginBottom: "15px",
    fontSize: "14px",
    border: "1px solid #f5c6cb",
  },

  loading: {
    color: "#0088cc",
    fontStyle: "italic",
    textAlign: "center",
    margin: "10px 0",
    fontSize: "0.9rem",
  },

  success: {
    color: "#155724",
    backgroundColor: "#d4edda",
    padding: "10px",
    borderRadius: "4px",
    marginBottom: "15px",
    fontSize: "14px",
    border: "1px solid #c3e6cb",
  },

  info: {
    color: "#0c5460",
    backgroundColor: "#d1ecf1",
    padding: "10px",
    borderRadius: "4px",
    marginBottom: "15px",
    fontSize: "14px",
    border: "1px solid #bee5eb",
  },

  chartGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "15px",
    width: "100%",
  },

  chartItem: {
    width: "100%",
  },

  card: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: "6px",
    padding: "15px",
    marginBottom: "15px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },

  cardHeader: {
    fontWeight: "600",
    marginBottom: "10px",
    paddingBottom: "8px",
    borderBottom: "1px solid #eee",
  },
};

export default GlobalStyles;
